import React, { SetStateAction, useState, Dispatch } from 'react';
import {
    Button,
    CssBaseline,
    TextField,
    Link,
    Grid,
    Typography,
} from '@material-ui/core';
import {
    makeStyles,
    createStyles,
    withStyles,
    WithStyles,
} from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

import { useHistory } from 'react-router-dom';

import axios from 'axios';

import { COLORS } from '../Theme';
import { SIcon } from '../Icon';

import {
    oper as v_oper,
    basic,
    Values,
    SNACKBAR_TIME,
} from '../../request/values';
//import LongPressable from 'react-longpressable';
import { useLongPress } from 'use-long-press';
import { useCookies } from 'react-cookie';
import ToastStr from '../../request/toastStr';
import { useSnackbar } from 'notistack';
import useCommonStyles from './../commonStyles/headerEmpty/useCommonStyles';

const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
    background: {
        position: 'absolute',
        top: 0,
        width: '100vw',
        height: '100vh',
        background: `url("/images/background.png")`,
    },
    container: {
        padding: 0,
        height: '100vh',
        paddingTop: '15vh',
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    title: {
        width: '80%',
        alignItems: 'left',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '80%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        height: 60,
        margin: theme.spacing(3, 0, 2),
        borderRadius: '27px',
        boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        border: 'solid 0.5px #cfd4d9',
        backgroundColor: `${COLORS.WATER_BLUE}`,
        '&:hover': {
            backgroundColor: `${COLORS.WATER_BLUE}`,
        },
    },
    logoSection: {
        // position: 'absolute',
        // bottom: '5vh',
        // width: '100vw',
        // textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        flex: 1,
        alignItems: 'flex-end',
        marginTop: '30vh',
    },
    logobutton: {
        border: 'none',
        backgroundColor: 'transparent',
    },
}));

const OperLoginIn: React.FC<any> = (props) => {
    const classes = useStyles();
    const commonClasses = useCommonStyles();

    const [email, setEmail] = useState<any | null>();
    const [password, setPassword] = useState<any | null>();
    const history = useHistory();
    const [cookies, setCookie, removeCookie] = useCookies();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const { oper, setOper } = props;

    const handleLogin = (oper: any) => {
        console.log('in Login handleLogin', oper);
        if (oper) {
            if (oper.classCode === null || oper.classCode.length == 0) {
                history.push({
                    pathname: '/ClassEnter',
                });
            } else {
                history.push({
                    pathname: '/',
                });
            }
        }
    };

    const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value } = e.target;

        if (id == 'email') setEmail(value);
        else setPassword(value);
    };

    const moveMember = () => {
        history.push('/');
    };

    const moveOperJoin = () => {
        history.push('/operation/join');
    };

    const moveOperPassword = () => {
        history.push('/operation/password');
    };

    const submitHandler = (event: any) => {
        console.log('click submit');

        axios({
            method: 'POST',
            data: {
                email: email,
                password: password,
            },
            withCredentials: true,
            url: SERVER + v_oper.oper + v_oper.login,

            headers: {
                'Access-Control-Allow-Origin': basic.server_url,
                mode: 'cors',
                'Access-Control-Allow-Headers':
                    'Origin, X-Requested-With, Content-Type, Accept',
            },
        })
            .then((res) => {
                return res.data;
            })
            .then((data: any) => {
                console.log(data);
                if (data.code == Values.FAIL_CODE) {
                    enqueueSnackbar(ToastStr.LOGIN_FAIL, {
                        variant: 'error',
                        autoHideDuration: SNACKBAR_TIME,
                    });
                } else {
                    // axios.defaults.headers.common[
                    //     'Authorization'
                    // ] = `Bearer ${data.jwt}`;
                    setOper(data.oper);
                    handleLogin(data.oper);
                }
            })
            .catch((error: any) => {
                if (error.response) {
                    console.log('error?', error.response);
                    if (error.response.status == 400) {
                        enqueueSnackbar(ToastStr.LOGIN_FAIL, {
                            variant: 'error',
                            autoHideDuration: SNACKBAR_TIME,
                        });
                    } else if (error.response.status === 401) {
                        console.log(error.response.data.msg);
                        if (error.response.data.msg === 'notApproved') {
                            enqueueSnackbar(ToastStr.ID_APPROVE_FAIL_STR, {
                                variant: 'warning',
                                autoHideDuration: SNACKBAR_TIME,
                            });
                        } else {
                            enqueueSnackbar(ToastStr.PWD_CHECK_FALSE_STR, {
                                variant: 'error',
                                autoHideDuration: SNACKBAR_TIME,
                            });
                        }
                    }
                }
            });
    };

    const buttonToMem = useLongPress(moveMember, {
        threshold: 3000,
        captureEvent: true,
        cancelOnMovement: false,
    });

    return (
        <div className={classes.background}>
            <Container component="main" className={classes.container}>
                <CssBaseline />
                <div className={classes.paper}>
                    <div className={classes.title}>
                        <div className={commonClasses.titleLeft}>
                            플레이스타트업
                            <br />
                            운영진 페이지입니다!
                        </div>
                    </div>

                    <div className={classes.form}>
                        <TextField
                            variant="standard"
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="ID"
                            name="email"
                            autoComplete="email"
                            autoFocus
                            value={email}
                            onChange={valueChangeHandler}
                            style={{ color: `${COLORS.charcoal_grey}` }}
                        />
                        <TextField
                            variant="standard"
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="PASSWORD"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            value={password}
                            onChange={valueChangeHandler}
                            style={{ color: `${COLORS.charcoal_grey}` }}
                        />
                        {/* <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
          /> */}
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            className={classes.submit}
                            onClick={submitHandler}
                        >
                            <Typography variant="h3">
                                운영진 로그인하기
                            </Typography>
                        </Button>

                        <Grid
                            container
                            justify="center"
                            style={{
                                flexDirection: 'column',
                                textAlign: 'center',
                                gap: '10px',
                            }}
                        >
                            <Grid item>
                                <Button onClick={() => moveOperJoin()}>
                                    <Typography
                                        variant="h2"
                                        style={{ color: `${COLORS.DOWN}` }}
                                    >
                                        회원가입하기
                                    </Typography>
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button onClick={() => moveOperPassword()}>
                                    <Typography
                                        style={{
                                            color: `${COLORS.DOWN}`,
                                            fontSize: '12px',
                                            textDecoration: 'underline',
                                        }}
                                    >
                                        비밀번호를 잊어버렸나요?
                                    </Typography>
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                    <div className={classes.logoSection}>
                        <button {...buttonToMem} className={classes.logobutton}>
                            <SIcon type="P" />
                        </button>
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default OperLoginIn;

/*
<div className={classes.logoSection}>
          <LongPressable
            onLongPress={() => moveMember()}
            longPressTime={3000}
          ><SIcon type="P" />
          </LongPressable>
        </div>
*/
